goog.provide('el8.appchart.mainFeeds.ChartFeed');

goog.require('el8.appchart.cqmRefresh');
goog.require('el8.uiwidget.FilterableFeed');
goog.require('el8.appservice.highlighter');
goog.require('el8.uiwidget.deleteConfirm');
goog.require('el8.uiwidget.Hover');
goog.require('el8.app.pageLayout');
goog.require('el8.appchart.mainFeeds.chartTimeline');
goog.require('el8.data.referencedUsers');
goog.require('el8.ptdata.plrCollaborators');
goog.require('el8.service.tz');
goog.require('el8.util.consts');
goog.require('el8.template.appchart.mainFeeds');
goog.require('el8.practicedata.immunizationRegistries');


/**
 * See https://github.com/elationemr/hippo/wiki/Chart-Feed
 * for an overview of the various pieces of the chart feed
 */
el8.appchart.mainFeeds.ChartFeed = function(spec) {

    spec = spec || {};
    var that = this;

    $.extend(spec, {
        rendererConstructor: el8.appchart.mainFeeds.ChartFeedRenderer,
        resetFilterFn: function() {
            that._feedRenderer._scrollContainer.find('.filterResultsNotifier').remove();
            that.updateMagicTable(null);
            el8.appservice.highlighter.setSearchTerms(null);
        },
        filteredCallbackFn: function(urlData, data) {
            var textQuery = urlData.q;
            that.updateMagicTable(data['magic_table'], textQuery);
            if (data['search_terms']) {
                el8.appservice.highlighter.setSearchTerms(data['search_terms']);
            }
            if (el8Globals['TEASE']) {
                if (!data['feed_index'].length) {
                    $(document).trigger('failed-chart-feed-search');
                } else {
                    $(document).trigger('successful-chart-feed-search');
                    if (textQuery.toLowerCase() === 'cholesterol') {
                        $(document).trigger('successful-cholesterol-search');
                    } else {
                        $(document).trigger('failed-cholesterol-search');
                    }
                }
            }
        }
    });

    el8.uiwidget.FilterableFeed.prototype.constructor.call(this, spec);

};
el8.appchart.mainFeeds.ChartFeed.inheritsFrom(el8.uiwidget.FilterableFeed);

el8.appchart.mainFeeds.ChartFeed.prototype.init = function() {
    var that = this;

    this._sortByProviderActivity =
        (el8.data.practiceSettings.getPatientChartSortStr() === 'provider') ? true : false;

    el8.uiwidget.FilterableFeed.prototype.init.apply(this, arguments);

    if (this._filterNoBind) {
        // We're going to do something custom and manually bind

        var CARETEAM_SOURCE_ID = -1;
        var ORDER_TYPE_ID = -2;
        var MED_TYPE_ID = -3;
        var LETTER_TYPE_ID = -4;

        var docTypeToId = _.invert(el8Globals.EL8_ID_TYPES);

        this._parseVSModels = function(searchCollection) {
            var searchParams = {};
            var textTerms = [];
            searchCollection.models.forEach(function(facet) {
                if (facet.attributes.category === el8.util.consts.DOCTYPE_FACET_VALUE) {
                    if (facet.attributes.id === ORDER_TYPE_ID) {
                        searchParams['doc_types'] = [
                            docTypeToId.LabOrder,
                            docTypeToId.ImagingOrder,
                            docTypeToId.CardiacOrder,
                            docTypeToId.PulmonaryOrder,
                            docTypeToId.SleepOrder
                        ];
                    } else if (facet.attributes.id === MED_TYPE_ID) {
                        searchParams['doc_types'] = [
                            docTypeToId.MedOrder,
                            docTypeToId.DiscontinueMedOrder,
                            docTypeToId.RxHistoryDownloadSummary
                        ];
                    } else if (facet.attributes.id === LETTER_TYPE_ID) {
                        searchParams['doc_types'] = [
                            docTypeToId.Letter,
                            docTypeToId.LetterReceipt
                        ];
                    } else {
                        searchParams['doc_types'] = [facet.attributes.id];
                    }
                }
                if (facet.attributes.category === el8.util.consts.SHARED_BY_FACET_VALUE) {
                    if (facet.attributes.id === CARETEAM_SOURCE_ID) {
                        searchParams['doc_source'] = 'careteam';
                    } else {
                        searchParams['doc_source'] = facet.attributes.id;
                    }
                }
                if (facet.attributes.category === el8.util.consts.VISIT_NOTE_TYPE_FACET_VALUE) {
                    searchParams['visit_note_types'] = [facet.attributes.id];
                }
                if (facet.attributes.category === 'text') {
                    textTerms.push(facet.attributes.value);
                }
            });
            searchParams['q'] = textTerms.join(' ');

            return searchParams;
        };

        this._vs = VS.init({
            autosearch : true,
            container  : $('#chart-feed-search-input'),
            appendTo   : this._feedRenderer._hoverSection,
            query      : '',
            showFacets : true,
            unquotable : [], // for serialization
            helpText   : 'Select a document filter or type text to search:',
            callbacks : {
                search: function(q, searchCollection) {
                    that.filter(that._parseVSModels(searchCollection));

                    if (searchCollection.models.length > 0) {
                      var amplitudeData = {};
                      searchCollection.models.forEach(function (model) {
                        var value = model.attributes.value;
                        switch (model.attributes.category) {
                          case 'text':
                          amplitudeData.text = value;
                          break;
                          case el8.util.consts.DOCTYPE_FACET_VALUE:
                          amplitudeData.type = value;
                          break;
                          case el8.util.consts.SHARED_BY_FACET_VALUE:
                          amplitudeData['collaborative view'] = value;
                          break;
                        }
                      });
                      el8.util.amplitude.logEvent('search chronological record', amplitudeData);
                      el8.util.amplitude.addUserProperty('number of chronological record searches', 1);
                      $('#reqact-collapse-trigger').trigger('el8_collapse');
                      $('#outstanding-collapse-trigger').trigger('el8_collapse');
                    }
                },
                clearSearch: function(actualClearSearch) {
                    actualClearSearch();
                    $(document).trigger('cleared-chart-feed-search');
                },
                facetMatches : function(callback) {
                    // "facets" in this list are objects of {label: '', value: ''}
                    // See http://api.jqueryui.com/autocomplete/#option-source
                    var facetList;

                    if (el8.ptdata.plrCollaborators.all().length) {
                        facetList = [
                            {
                                label: el8.template.appchart.mainFeeds.typeFacet(),
                                value: el8.util.consts.DOCTYPE_FACET_VALUE
                            },
                            {
                                label: el8.template.appchart.mainFeeds.sharedByFacet(),
                                value: el8.util.consts.SHARED_BY_FACET_VALUE
                            }
                        ];
                    } else {
                        facetList = [
                            {
                                label: el8.template.appchart.mainFeeds.typeFacet(),
                                value: el8.util.consts.DOCTYPE_FACET_VALUE
                            }
                        ];
                    }

                    // pass the "singleFacet" option to prevent multiple facets of the same category
                    // "this" is the current searchInput, pass it to the callback to enable "singleFacet"
                    callback.call(
                        this,
                        facetList,
                        {singleFacet: true}
                    );
                },
                // search terms used the in the autocomplete
                valueMatches : function(facet, searchTerm, callback) {
                    switch (facet) {
                        // `label` is what's shown in the autocomplete,
                        // `value` is what is inserted into the search box,
                        // `id` is what we'll send to the server
                        case el8.util.consts.DOCTYPE_FACET_VALUE:
                            // These will return results for PLR and local searches
                            var docTypes = [
                                { value: 'Visit Notes', id: docTypeToId.VisitNote },
                                { value: 'Reports', id: docTypeToId.Report},
                                { value: 'Non-Visit Notes', id: docTypeToId.NonvisitNote },
                                { value: 'Orders', id: ORDER_TYPE_ID }
                            ];
                            // These ones are only relevant for local searches. We can't stop people
                            // from doing PLR searches for them (e.g., by selecting a Type and then
                            // a Source), but we can at least help train them
                            var sourceAttrIndex = _.find(that._vs.searchQuery.models, function(m) {
                                return m.attributes.category === el8.util.consts.SHARED_BY_FACET_VALUE;
                            });
                            if (sourceAttrIndex === undefined) { // no Source = local search
                                docTypes = docTypes.concat([
                                    { value: 'Messages', id: docTypeToId.MessageThread },
                                    { value: 'Letters & Referrals', id: LETTER_TYPE_ID },
                                    { value: 'Medications', id: MED_TYPE_ID },
                                    { value: 'Pt Summaries (CCD/CCDA)', id: docTypeToId.XmlPatientSummary }
                                ]);
                            }
                            docTypes = _.sortBy(docTypes, 'value');
                            docTypes.forEach(function(t) {
                                t.label = t.value;
                            });
                            callback( docTypes, {preserveOrder: true} );
                            break;
                        case el8.util.consts.SHARED_BY_FACET_VALUE:
                            var sources = [];
                            // all careteam should be the first source
                            sources.push({ value: 'All Sharing Providers', label: 'All Sharing Providers', id: CARETEAM_SOURCE_ID });

                            sources = sources.concat(
                                el8.ptdata.plrCollaborators.all().map(function(collab) {
                                    return {
                                        value: collab.getPhysicianName(),
                                        label: collab.getPhysicianName(),
                                        id: collab.getPracticeId()
                                    };
                                })
                            );
                            callback(sources, {preserveOrder: true});
                            break;
                    }
                }
            }
        });

    } else {
        if (this._clearFilterBtn) {
            this._container.on('click', this._clearFilterBtn, function(e) {
                $(document).trigger('cleared-chart-feed-search'); // TODO see if this works
            });
        }
    }
};
el8.appchart.mainFeeds.ChartFeed.prototype.filter = function(q) {
    if (el8Globals['TEASE']) { $(document).trigger('submit-chart-feed-search'); }
    /* If pass in empty query, just do a refresh and return */
    if (!q.q && !q.doc_source && !q.doc_types && !q.visit_note_types) {
        this.refresh();
        return;
    }

    el8.uiwidget.FilterableFeed.prototype.filter.call(this, q);
};

el8.appchart.mainFeeds.ChartFeed.prototype.getFilterFieldVal = function() {
    if (this._filterNoBind) {
        return this._vs.searchBox.value();
    } else {
        return el8.uiwidget.FilterableFeed.prototype.getFilterFieldVal.call(this);
    }
};
el8.appchart.mainFeeds.ChartFeed.prototype.setFilterFieldVal = function(val) {
    if (this._filterNoBind) {
        if (_.isObject(val)) {
            // if this is a faceted search, clear the VS,
            // put the faceted data in there, and re-render
            this._vs.searchQuery.reset();
            this._vs.searchBox.addStructuredFacet(val);
            this._vs.searchBox.renderFacets();
        } else {
            this._vs.searchBox.value(val);
        }

    } else {
        el8.uiwidget.FilterableFeed.prototype.setFilterFieldVal.call(this);
    }
};
el8.appchart.mainFeeds.ChartFeed.prototype.focusInput = function() {
    if (this._filterNoBind) {
        this._vs.searchBox.focusSearch({});
    } else {
        $('#chart-feed-search-input').focusFocus();
    }
};

/**
 * Over-ride load-index to address Chart Timeline-related needs
 */
el8.appchart.mainFeeds.ChartFeed.prototype.loadIndex = function(index) {
    /* In order to load graph, need to initialize the feed
     * and append skeleton to DOM */
    if (!this._isInit) { this.init(); }
    el8.uiwidget.FilterableFeed.prototype.loadIndex.apply(this, arguments);
    el8.appchart.mainFeeds.chartTimeline.loadGraph(index);
};

/**
 * Helpful method for the feed to expose
 * - Returns the date of the "n-th" most recent visit for the patient
 */
el8.appchart.mainFeeds.ChartFeed.prototype.getLastVisitDate = function(n) {
    n = n || 0;
    var index = this._feedData.getDataIndex();
    var count = 0;
    for (var i=0; i<index.length; i++) {
        if (index[i].model_class === 'VisitNote') {
            if (count >= n) {
                return el8.service.tz.toTzDateTime(index[i]['feed_date']);
            }
            count += 1;
        }
    }
    return null;
};

/**
 * To support UI "preview" -- "fake" add because isn't actually registered in index
 */
el8.appchart.mainFeeds.ChartFeed.prototype.addPreview = function(item) {
    this.freeze();
    this._feedRenderer.addPreview(item);
};
el8.appchart.mainFeeds.ChartFeed.prototype.removePreview = function(id) {
    var that = this;
    return this._feedRenderer.removePreview(id,
        function() { that.unfreeze(); });
};


/**
 * When updating the feed, if we have a search filter on, we redo the search.
 * Helps for PLR case where we still want to update the feed but can't simply
 * update the list with local data.  If no search criteria, then we do update()
 * as normal (which will not update the feed if freeze() has been called)
 */
el8.appchart.mainFeeds.ChartFeed.prototype.update = function(opts) {
    if (this.getFilterFieldVal()) {
        this.refreshChartSearch();
    }
    else {
        el8.uiwidget.Feed.prototype.update.call(this, opts);
    }
};

/**
 * Magic Table!
 */
el8.appchart.mainFeeds.ChartFeed.prototype.updateMagicTable = function(results, query) {
    /**
     * Sets us up to display (or clear) a table of lab results at the top of the feed.
     **/
    if (results && results.groups) {
        var that = this;
        results.groups.forEach(that._postProcessMagicTableGroup);
    }
    this._magicTableData = results;
    var container = $('#lab-results-table-holder');
    if (this._magicTableData) {
        container.html(el8.template.appchart.mainFeeds.chartMagicTable({
            results : this._magicTableData,
            query : query,
            patientAge : el8.ptdata.currPatient ? el8.ptdata.currPatient.getAge() : null,
            currentPracticeId : el8.data.currPractice.getId(),
            showForecast: el8.practicedata.immunizationRegistries.canCheckRegistryHistoryForecast(),
        })).show();
        this._bindMagicTableEvents();

        $('.small-manual-doc-item', container).each(function(i, tooltipAnchor) {
            var documentingUser = null;
            var str = 'This value was entered manually';
            var id = $(tooltipAnchor).data('personnel-id');
            if (id) { documentingUser = el8.data.referencedUsers.getById(id); }
            if (documentingUser) { str = 'Manually entered by ' + documentingUser.getFullName(); }

            el8.service.tooltip.create({
                anchor: $('.small-manual-doc-item', container),
                text: str
            });
        });

    } else {
        $('.small-manual-doc-item', container).each(function(i, tooltipAnchor) {
            el8.service.tooltip.destroy($(tooltipAnchor));
        });

        container.empty().hide();
    }
};
el8.appchart.mainFeeds.ChartFeed.prototype.getMagicTableData = function() {
    return this._magicTableData;
};

// called from links in showing visit notes and nvns
/**
 * 
 * @param {*} q 
 * @param {boolean} isInitialLoad Indicates it is the chart's first render
 */
el8.appchart.mainFeeds.ChartFeed.prototype.doChartSearch = function(q, isInitialLoad) {
    this.setFilterFieldVal(q);
    if (_.isObject(q)) {
        // if this is a faceted search, the data we put in the filter
        // field and the data we send to the server may not match up
        // (e.g., 'Shared By' vs. 'doc_source'), so this fn expects the data VS
        // will want and then parses out what the server wants
        var parsedQ = this._parseVSModels(this._vs.searchQuery);
        this.filter(parsedQ);
    } else {
        this.filter({q: q});
    }
    if(!isInitialLoad) {
        $('#reqact-collapse-trigger').trigger('el8_collapse');
        $('#outstanding-collapse-trigger').trigger('el8_collapse');
    }
};
/**
 * 
 * @param {boolean} isInitialLoad Indicates if chart search is on page load
 */
el8.appchart.mainFeeds.ChartFeed.prototype.doCareteamSearch = function(isInitialLoad) {
    this.doChartSearch({ category: el8.util.consts.SHARED_BY_FACET_VALUE, value: 'All Sharing Providers', id: -1 }, isInitialLoad);
};

// called when a chart search is open and the current action is expected to
// change the results (vaccine magic table, PLR)
el8.appchart.mainFeeds.ChartFeed.prototype.refreshChartSearch = function() {
    if (this._filterNoBind) {
        var searchParams = this._parseVSModels(this._vs.searchQuery);
        this.filter(searchParams);
    } else {
        this.filter(this.getFilterFieldVal());
    }

};

/**
 * Helpful method to clear filters
 * - Used in Vitals filter button to clear facets before doing a chart search.
 */
el8.appchart.mainFeeds.ChartFeed.prototype.resetFilters = function() {
    this._vs.searchQuery.reset();
};

el8.appchart.mainFeeds.ChartFeed.prototype.isMagicTableShowing = function() {
    return Boolean(this._magicTableData);
};
el8.appchart.mainFeeds.ChartFeed.prototype.scrollToMagicTable = function() {
    this._feedRenderer.scrollToMagicTable();
};



/**
 * Annotate a group for the magic table with documenting_personnel_type (staff or physician)
 * so that the appropriate icon type can be displayed. Right now, we only do this for labs.
 *
 * @param {Object} magicTableGroup
 */
el8.appchart.mainFeeds.ChartFeed.prototype._postProcessMagicTableGroup = function(magicTableGroup) {
    if (!magicTableGroup || !magicTableGroup.rows) { return; }

    if (magicTableGroup.type === 'vitals') {
        // If a 2-col visit note is open, add a note that these vitals were reviewed
        var numVisits = _.filter(magicTableGroup.dates, function(d) { return Boolean(d); }).length;
        el8.appchart.mgr.notes.addVitalsNote(numVisits);
        return;
    }
    if (magicTableGroup.type !== 'labs') { return; }

    for (var i=0; i<magicTableGroup.rows.length; i++) {
        var row = magicTableGroup.rows[i];
        if (!row.values) { continue; }
        for (var j=0; j < row.values.length; j++) {
            var value = row.values[j];
            if (value.documenting_personnel_id) {
                var documentingUser = el8.data.referencedUsers.getById(value.documenting_personnel_id);
                if (!documentingUser) { continue; }
                value.documenting_personnel_type = documentingUser.getStaffType();
            }
            if (value.authoring_practice_id !== el8.data.currPractice.getId()) {
                value.is_from_care_team = true;
            }
        }
    }
};
el8.appchart.mainFeeds.ChartFeed.prototype._bindMagicTableEvents = function() {
    var that = this;
    var container = $('#lab-results-table-holder');
    var $vaccineMagicTable = $('.vaccine-magic-table', container);
    if ($vaccineMagicTable.length) {
        var saveQuickImm = function() {
            var $this = $(this);
            var rawVal = $this.val();
            if (!rawVal) { return false; }

            var date = el8.util.datecompare.processDateInput(rawVal);
            if (!date) { return false; }
            if (el8.util.datecompare.isAfterToday(date)) {
                el8.uiwidget.alert('Date must be today or before.', $this);
                return;
            }

            var data = {
                cdc_type: $this.data('name'),
                administered_date: el8.service.tz.asServerFormatDate(date)
            };

            var $quickForm = $this.closest('.imm-quick-form');
            var $li = $(el8.template.appchart.mainFeeds.tempPtImmCell()).insertBefore($quickForm);
            if ($quickForm.siblings('li').length === 6) {
                // remove() will trigger blur() so unbind the blur event from the datepicker to avoid double saving
                $this.unbind('blur');
                $quickForm.remove();
            }
            $this.val('');
            $.el8_ajax({
                type: 'POST',
                url: el8.service.urls.get('quickPtImmunization'),
                data: JSON.stringify(data),
                success: function(data) {
                    el8.ptdata.ptImmunizations.create(data.item, true); // don't refresh magic table
                    el8.appchart.refpanel.immunizations.triggerRefresh(); // but do refresh the LHS
                    $li.replaceWith(
                        el8.template.appchart.mainFeeds.ptImmCell({
                            id: data.item.id,
                            date: data.item.administered_date
                        })
                    );
                    el8.appchart.cqmRefresh.forceRefresh(true);
                }
            });
            return true;
        };

        $(':input[name="administeredDate"]', $vaccineMagicTable).each(function() {
            var infoField = el8.service.infoField.addInfoField({
                field: $(this),
                infoText: 'Add date only',
                maxLength: 10
            });
            el8.uiwidget.addDatepicker(infoField, {
                dateSelectedFn: saveQuickImm,
                maxDate: el8.service.tz.today()
            });
        });
        $vaccineMagicTable.on('keydown', ':input[name="administeredDate"]',  function(e) {
            if (e.keyCode === KEYS.ENTER || e.keyCode === KEYS.TAB) {
                if (saveQuickImm.call(this)) {
                    e.preventDefault();
                    e.stopPropagation(); // prevent the 'blur' from firing
                    if ($.contains(document.documentElement, this)) {
                        $(this).focusFocus();
                    } else {
                        // we removed this form from the DOM - jumpt to the next one
                        var newIndex = $(this).closest('.imm-quick-form').data('index') + 1;
                        $('.imm-quick-form[data-index="'+newIndex+'"]', $vaccineMagicTable)
                            .find(':input[name="administeredDate"]').focusFocus();
                    }
                    return false;
                }
            }
        });
        // blur event handled by datepicker (runs dateSelectedFn above)
        $vaccineMagicTable.on('focus', ':input[name="administeredDate"]',  function(e) {
            var $this = $(this);
            if ($this.closest('.imm-quick-form').siblings('li').length > 3) {
                $(this).closest(':scrollable').scrollTo('100%', { axis: 'x' });
            } else {
                $(this).closest(':scrollable').scrollTo('0%', { axis: 'x' });
            }
        });
        $vaccineMagicTable.on('click', '.delete-trigger',  function() {
            var id = $(this).data('id');
            var deleteItemFn = function() {
                if (el8.model.idToModelClass(id) === 'PatientImmunization') {
                    el8.ptdata.ptImmunizations.deleteItem(id);
                } else {
                    el8.ptdata.ptImmunizationDeclines.deleteItem(id);
                }
            };
            el8.uiwidget.deleteConfirm('immunization', deleteItemFn);
            return false; // stop propagation from opening the immunization dialog
        });
        var scrollFn = function() {
            // manipulates shadows depending on the horizontal scroll position
            var $leftShadow = $('.left-scroll-shadow', $vaccineMagicTable);
            if (this.scrollLeft > 5) { // if we scroll to a few pixels shy of the left edge, treat is as the edge
                if (!$leftShadow.hasClass('el8ValuesHeaderShadow')) { $leftShadow.addClass('el8ValuesHeaderShadow'); }
            } else {
                if ($leftShadow.hasClass('el8ValuesHeaderShadow')) { $leftShadow.removeClass('el8ValuesHeaderShadow'); }
            }

            var $rightShadow = $('.right-scroll-shadow', $vaccineMagicTable);
            if (this.scrollWidth - this.scrollLeft <= $(this).outerWidth()) {
                if ($rightShadow.is(':visible')) { $rightShadow.hide(); }
            } else {
                if (!$rightShadow.is(':visible')) { $('.right-scroll-shadow', $vaccineMagicTable).show(); }
            }
        };
        $('.vaccine-scrollable', $vaccineMagicTable).scroll(_.throttle(scrollFn, 100));
        if ($('.vaccine-set-dropdown', $vaccineMagicTable).length) {
            $vaccineMagicTable.on('change', '.vaccine-set-dropdown',  function() {
                that.doChartSearch($(this).val());
            });
        }
    }
};

// ========================================================
// Customize Feed Renderer for chart feed
// ========================================================
el8.appchart.mainFeeds.ChartFeedRenderer = function(spec) {
    spec = spec || {};
    el8.uiwidget.FilterableFeedRenderer.prototype.constructor.call(this, spec);

};
el8.appchart.mainFeeds.ChartFeedRenderer.inheritsFrom(el8.uiwidget.FilterableFeedRenderer);

el8.appchart.mainFeeds.ChartFeedRenderer.prototype.init = function() {
    el8.uiwidget.FilterableFeedRenderer.prototype.init.apply(this, arguments);
    var $navHolder = $('#chart-feed-navigator-holder');
    this._hoverSection = $('.chart-feed-navigator', $navHolder);
    var that = this;

    $navHolder.css({
        position: 'sticky',
        top: 0,
        'z-index': 3,
        'margin-bottom': '8px'
    });
    $('.el8ChartFeedContainer').css('max-width', '1050px');
    $('.el8ChartFeedContainer .chart-feed-navigator').css({
        width: '100%',
        padding: '10px 10px 3px 10px',
        'background-color': 'rgba(239, 239, 239, 0.95)',
        'box-shadow': '0 2px 2px rgba(0, 0, 0, 0.15)'
    });
    $('.el8MainChartContainer').css('background', '#efefef');

    // bind the "back to top" link
    $('#chart-feed-back-to-top').css('display', 'inline-block');
    $(document).on('click', '#chart-feed-back-to-top-trigger',  function() {
        that.scrollToTop();
    });
};

el8.appchart.mainFeeds.ChartFeedRenderer.prototype._drawPageItems = function(page, force) {

    el8.uiwidget.FilterableFeedRenderer.prototype._drawPageItems.apply(this, arguments);

    var start = this._renderedPage.getStart();
    var end = this._renderedPage.getEnd();
    if (start < end) {
        try {
            el8.appchart.mainFeeds.chartTimeline.showPageOnGraph(
                el8.service.tz.toTzDateTime(this._feedData.getDataIndex()[start]['feed_date']),
                el8.service.tz.toTzDateTime(this._feedData.getDataIndex()[end-1]['feed_date']));
        } catch (ex) {
            var msg = 'feedData.getDataIndex()[end-1] was undefined:\n' +
                'page start='+start+'; page end='+end+'; index length='+this._feedData.getDataIndex().length+'\n\n' +
                JSON.stringify(this._feedData.getDataIndex());
            UIM && UIM.logError(msg);
        }
    }

};

/**
 * Support for scrolling
 */
el8.appchart.mainFeeds.ChartFeedRenderer.prototype.scrollToTop = function(opts) {
    opts = opts || {};

    var windowHeight = el8.app.pageLayout.getAppHeight();
    if (this._container.height() < windowHeight) {
        this._container.height(windowHeight);
    }

    // With the new search bar positioning, only scroll to the top of the chart feed if
    // explicitly requested. Add a delta to clear the current height of the search/notifier
    // container as well.
    var $navSection = $('.chart-feed-navigator', $('#chart-feed-navigator-holder'));
    if (opts.scrollToFeed) {
        this._scrollContainer.scrollTo(this._container, {offset: -$navSection.height()});
    } else {
        this._scrollContainer.scrollTo(0);
    }
};
el8.appchart.mainFeeds.ChartFeedRenderer.prototype.scrollToMagicTable = function() {
    // Scrolling to the correct container first in case the table hasn't been rendered yet
    // Since this is currently the case the first time the button is pressed
    this._scrollContainer.scrollTo('#chart-feed-container');
    this._scrollContainer.scrollTo('#lab-results-table-holder');
};

/**
 * Support for preview item
 */
el8.appchart.mainFeeds.ChartFeedRenderer.prototype.addPreview = function(item) {
    this._previewedNoteId = item.getId();
    // Mimic indexedItem for the sake of _renderItem function
    var indexedItem = {'id': item.getId()};
    this._$previewedNote = $(this._renderItem(item, indexedItem));
    this._list.prepend(this._$previewedNote);
    if (this._addlRenderItemFn) {
        this._addlRenderItemFn(this._$previewedNote, item);
    }
    // If this is an amendment, hide existing signed note in feed
    if (item.getCurrentEditId()) {
        var feedItemId = el8.appchart.mainFeeds.chart.getFeedId(item.getId()).replace('preview_','');
        this._$existingNote = $('#'+feedItemId, this._container).hide();
    }
    this._scrollContainer.scrollTo(this._$previewedNote);
    /* Scroll less 100px to leave some padding in case of hover bar */
    this._scrollContainer.scrollTo("-=100px");
};
el8.appchart.mainFeeds.ChartFeedRenderer.prototype.removePreview = function(id, onRemoveFn) {
    if (id !== this._previewedNoteId) { return; }
    if (this._$existingNote) { this._$existingNote.show(); }
    if (onRemoveFn) { onRemoveFn(); }
    this._previewedNoteId = null;
    if (this._$previewedNote) {
        var fid = this._$previewedNote.attr('_fid');
        this._$previewedNote.remove();
        return fid;
    }
};
